/*
 * Copyright (c) Nexign, JSC, 2019-2020.
 */

/**
 * The label component for Category Chart
 *
 * @author Yakov Gushchin
 * @author Anton Panasenko
 * @author Maxim Fedorov
 * @author Aleksandr Perkhunov
 * @version 1.2.0
 * @since 1.1.0
 */

import { FC } from 'react';

import { EChartLabelType } from '../../../../../pages/PageExpensesAnalyzer/types/pageExpensesAnalyzerTypes';
import { EllipseText, TextBlock } from '../../../index';
import {
    ChartCategoryCityTextStyled,
    ChartCategoryLabelItemStyled,
    ChartCategoryLabelStyled,
} from './styled/ChartCategoryLabelStyled';

export interface IChartBarLabel {
    title: string;
    subTitle?: string;
    labelType: EChartLabelType;
}

export interface IChartBarLabelProps {
    labels: IChartBarLabel[];
    width: number;
}

const ChartCategoryLabel: FC<IChartBarLabelProps> = props => {

    const labelWidth = props.width / (props.labels.length || 1);

    return (
        <ChartCategoryLabelStyled style={{ width: props.width }}>
            {
                props.labels.map((label: IChartBarLabel) => (
                        <ChartCategoryLabelItemStyled key={label.title} style={{ maxWidth: labelWidth }}>
                            <EllipseText title={label.title}>
                                <TextBlock>{label.title}</TextBlock>
                            </EllipseText>
                            {
                                label.labelType === EChartLabelType.fio &&
                                label.subTitle &&
                                    <EllipseText title={label.subTitle}>
                                        <ChartCategoryCityTextStyled>
                                            {label.subTitle}
                                        </ChartCategoryCityTextStyled>
                                    </EllipseText>
                            }
                        </ChartCategoryLabelItemStyled>
                    ),
                )
            }
        </ChartCategoryLabelStyled>
    );
};

export default ChartCategoryLabel;
